var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLink = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.81 4.21a1.4 1.4 0 1 1 1.98 1.98l-2.1 2.1a1.4 1.4 0 0 1-1.98 0 .7.7 0 1 0-.99.99 2.8 2.8 0 0 0 3.96 0l2.1-2.1a2.8 2.8 0 1 0-3.96-3.96L7.77 4.27a.7.7 0 1 0 .99.99z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.31 7.71a1.4 1.4 0 0 1 1.98 0 .7.7 0 1 0 .99-.99 2.8 2.8 0 0 0-3.96 0l-2.1 2.1a2.8 2.8 0 0 0 3.96 3.96l1.05-1.05a.7.7 0 1 0-.99-.99l-1.05 1.05a1.4 1.4 0 0 1-1.98-1.98z"
  }))));
};
export default SvgLink;